import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import AmplitudeError from './amplitudeError'

export default class AmplitudeTimeoutError extends AmplitudeError {
  constructor(event: AmplitudeEvent, timeout: number) {
    super(event, { reason: `Event timed out after ${timeout}ms..`, code: 408 })

    this.name = 'AmplitudeTimeoutError'
  }
}
